import { domMeasurements } from '#packages/stateManagement';
import { fedopsLogger, extraHeight } from '#packages/util';
import { isSection } from '../../../api';

import type { CompRef } from 'types/documentServices';
import type { Scope } from '#packages/sections';

const resizeInteractions = fedopsLogger.mapInteraction(
  fedopsLogger.INTERACTIONS.CLASSIC_SECTIONS.RESIZE,
);

export const createResizeAndPushHooks = (scope: Scope) => {
  const { editorAPI } = scope;
  const { increaseExtraHeight, rollbackExtraHeight } =
    extraHeight.createHelpersForSafeResize(editorAPI);

  const start = async (compRef: CompRef) => {
    if (!isSection(scope, compRef)) return;
    resizeInteractions.start();
    const stageHeight = domMeasurements.selectors.getStageLayout(
      editorAPI.store.getState(),
    ).height;
    await increaseExtraHeight(compRef, stageHeight);
  };

  const end = async (compRef: CompRef) => {
    if (!isSection(scope, compRef)) return;
    await rollbackExtraHeight();
    resizeInteractions.end();
  };

  return {
    start,
    end,
  };
};
